<template>
<div>
    <div class="row">
      <div class="col-12">
        <h2>Events</h2>
        <hr>
      </div>
    </div>
  <div class="row">
    <div class="col-12">
      <router-link :to="{ name:'AlertAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
        Add Event
      </router-link>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-8">
      <table class="table table-striped">
        <thead class="bg-hub-primary text-white">
        <tr>
          <th>Name</th>
          <th class="d-none d-md-table-cell">Device</th>
          <th class="d-none d-md-table-cell">Input</th>
          <th>Extension</th>
          <th>Manage</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="alert in filtered_alerts" :key="alert.alert_id">
          <td>{{ alert.name }}</td>
          <td class="d-none d-md-table-cell" v-if="alert.device_id !== null"><a :href="'http://' + alert.device.ip" target="_blank">{{ alert.device.name }}</a></td>
          <td class="d-none d-md-table-cell" v-else>N/A</td>
          <td class="d-none d-md-table-cell" v-if="alert.device_id !== null">{{ alert.input_number }}</td>
          <td class="d-none d-md-table-cell" v-else>N/A</td>
          <td>
            <span v-if="alert.extension !== 0">{{ alert.extension }}</span>
            <span v-else>N/A</span>
          </td>
          <td>
            <div class="dropdown">
              <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link :to="{ name: 'AlertSummary', params: { alert_id: alert.alert_id } }" class="dropdown-item">
                  <i class="fa fa-tasks fa-fw" aria-hidden="true"></i>&nbsp;Summary
                </router-link>
                <a class="dropdown-item" href="#" onclick="return false" @click="deleteAlert(alert)"><i
                  class="fa fa-trash fa-fw"
                  aria-hidden="true"></i>&nbsp;Delete</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click="executeAlert(alert.alert_id)"><i
                  class="fa fa-play fa-fw" aria-hidden="true"></i> Execute</a>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      alerts: 'allAlerts',
      phoenix_settings: 'allPhoenixSettings',
      scoped_site_id: 'scopedSiteId',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled'
    }),
    filtered_alerts: function () {
      return this.alerts.filter(alert => alert.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getAlerts')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  methods: {
    ...mapActions([
      'deleteAlert',
      'executeAlert'
    ]),
    apply () {
      this.$store.dispatch('executeCommand', '2')
    }
  }
}
</script>

<style scoped>

</style>
